import { useEffect, useState } from "react";

export const ONBOARDING_GATE_MESSAGE =
  "Please complete the required registration process in the Salon / Independent Professionals Setup Wizard before continuing.";

export const ONBOARDING_STATUS_EVENT = "onboarding-status-updated";

export const isOnboardingComplete = () => {
  return (localStorage.getItem("onboarding_completed") || "").toLowerCase() === "true";
};

export const notifyOnboardingStatusChange = (completed) => {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(ONBOARDING_STATUS_EVENT, {
      detail: {
        completed: Boolean(completed),
      },
    })
  );
};

export const useOnboardingStatus = () => {
  const [completed, setCompleted] = useState(isOnboardingComplete());
  useEffect(() => {
    if (typeof window === "undefined") {
      return () => {};
    }
    const handler = () => {
      setCompleted(isOnboardingComplete());
    };
    window.addEventListener(ONBOARDING_STATUS_EVENT, handler);
    return () => window.removeEventListener(ONBOARDING_STATUS_EVENT, handler);
  }, []);
  return completed;
};

export const clearOnboardingDraft = () => {
  const keysToClear = [
    "onboarding_completed",
    "setup_wizard_step",
    "setupWizardStep",
    "setup_wizard_draft",
    "setupWizardDraft",
    "wizard_progress",
    "wizardProgress",
  ];
  keysToClear.forEach((key) => localStorage.removeItem(key));

  localStorage.setItem("onboarding_completed", "false");
  notifyOnboardingStatusChange(false);
};
